<template>
  <div>
    <div class="readme">
      <div class="title">README.md</div>
      <div class="content"><Readme /></div>
    </div>
  </div>
</template>
<script>
import Readme from '../../README.md'

export default {
  components: {
    Readme
  }
}
</script>
